import React from "react";
import { FeatureV2Props } from "./interfaces/FeatureV2";
import Icon from "../../utils/Icon";
import Text from "../Common/Text";
import Image from "../Common/Image";

const DEFAULDATA = {
  title: { value: "¡Explora la innovación con Dogtorsoftware!" },
  description: {
    value:
      "Simplifica tareas, mejora la productividad y disfruta de una experiencia única. ¡Bienvenido al futuro de la funcionalidad con Dogtorsoftware!\n\n",
  },
  image: {
    desktop:
      "https://assets.dogtorsoftware.com/1/website/2ca582aa-6a45-42b0-a9b0-9c84df992660.png",
  },
  features: [
    {
      id: "3b7f28c9-66c4-6d9e-a398-a4318591af98",
      description: { value: "Este es un ejemplo de una novedad" },
      title: "Novedad 1",
      icon: "FaRegFaceGrin",
    },
    {
      id: "0662b129-6add-b78a-c2dd-6b9e669624fd",
      description: { value: "Este es un ejemplo de una novedad" },
      title: "Novedad 1",
      icon: "FaRegFaceLaughWink",
    },
    {
      id: "2219c5ae-9674-e780-db58-3b0b5fc83890",
      description: { value: "Este es un ejemplo de una novedad" },
      title: "Novedad 1",
      icon: "FaRegFaceMehBlank",
    },
    {
      id: "31e14b35-0883-d48a-2c10-c272f34aa4b7",
      description: { value: "Este es un ejemplo de una novedad" },
      title: "Novedad 1",
      icon: "FaRegFaceGrimace",
    },
  ],
};

const FeatureV2 = ({
  data = DEFAULDATA,
  onChange,
}: {
  data: FeatureV2Props;
  onChange: (value: any, id?: string) => void;
}) => {
  return (
    <div>
      <div
        className="overflow-hidden  bg-[--primary600] pt-10"
        style={{
          backgroundImage:
            'url("https://assets.dogtorsoftware.com/1/website/6634b84d-0005-4ccf-8ec4-e1982c762d41.png")',
          backgroundPosition: "bottom center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <div className="lg:pr-8 lg:pt-4">
              <div className="lg:max-w-lg">
                <Text
                  editor={!!onChange}
                  id="FeatureV2"
                  onChange={(val: any) => {
                    onChange?.(val, "title");
                  }}
                >
                  {data?.title}
                </Text>

                <div className="mt-10 max-w-xl lg:max-w-none grid grid-cols-2 gap-5 ">
                  {data?.features?.map((feature, idx) => (
                    <div key={feature.id} className="relative">
                      {feature.icon && (
                        <div
                          className={`${
                            [1, 2, 4, 5, 5, 6].includes(idx)
                              ? "bg-white "
                              : "bg-[--primary400]"
                          } w-16 h-16  rounded-full mb-2 flex justify-center items-center`}
                        >
                          <Icon
                            nameIcon={feature.icon}
                            className={`text-2xl ${
                              [1, 2, 4, 5, 5, 6].includes(idx)
                                ? "text-[--primary700]"
                                : "text-white"
                            }`}
                          />
                        </div>
                      )}
                      <h4 className="inline font-semibold text-xl text-white">
                        {feature?.title}
                      </h4>
                      <p className="text-white font-light">
                        {feature?.description?.value}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <Text
                editor={!!onChange}
                id="FeatureV2"
                onChange={(val: any) => {
                  onChange?.(val, "description");
                }}
              >
                {data?.description}
              </Text>

              <Image
                {...data.image}
                className="w-[48rem] max-w-none rounded-xl mt-3 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
              />
            </div>
          </div>
        </div>
        <div className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100vw"
            height="209.775"
            style={{ marginTop: "-120px" }}
          >
            <path
              id="Path_1"
              data-name="Path 1"
              d="M0,425.789,4009.8,216.014V425.789Z"
              transform="translate(0 -216.014)"
              fill="#fff"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
export default FeatureV2;
